import * as ActionTypes from '../constants';
import axios from 'axios';
import { baseUrl } from '../constants/apiConstants';
import { LOGIN_REQUEST, LOGIN_RESPONCE, LOGIN_ERROR, CLEAR_LOGIN_INFO} from '../constants';


export default function(state={}, action) {
    switch(action.type) {
        case LOGIN_REQUEST: 
            return {
                ...state,
                loading: true,
                mobile: action.data,
                response: null,
                errInfo: null,
                err: false
            }
        case LOGIN_RESPONCE: 
            return {
                ...state,
                loading: false,
                response: action.res,
                err: false
            }
        case LOGIN_ERROR: 
            return {
                ...state,
                err: true,
                errInfo: action.err,
                loading: false
            }
        case CLEAR_LOGIN_INFO: 
            return {}
        default: return state;
    }
}

 

const dispatchRequestLogin = data => ({
    type: ActionTypes.LOGIN_REQUEST,
    data
})

const dispatchResponceLogin = res => ({
    type: ActionTypes.LOGIN_RESPONCE,
    res
})

const dispatchLoginError = err => ({
    type: ActionTypes.LOGIN_ERROR,
    err
})

export const dispatchClearLoginInfo = () => ({
    type: ActionTypes.CLEAR_LOGIN_INFO    
})

export function login(mobileNo) {
    // console.log(mobileNo, 'mobile no');
    return dispatch => {
        dispatch(dispatchRequestLogin(mobileNo));
        const data = {
            phone: mobileNo
        }

        axios.post(`${baseUrl}/api/login`, data)
            .then(res => {
                // console.log(res, 'success login')
                dispatch(dispatchResponceLogin(res));
            })
            .catch(e => {
                // console.log(e, 'error, login')
                dispatch(dispatchLoginError(e))
            });
    }
}

